import { gql } from '@apollo/client';

const WALLET_STATEMENT_LINE_FIELDS = gql`
  fragment WalletStatementLineFields on WalletStatementLine {
    id
    kind
    at
    amount_cents
    since_day
    source
    earning_kind
    referred_user_name
    course_title
    reversal_reason
    payout_kind
    payout_status
    paid_at
  }
`;

export const MY_WALLET_STATEMENT = gql`
  query MyWalletStatement($from: String, $to: String) {
    myWalletStatement(from: $from, to: $to) {
      from
      to
      today
      opening_balance_cents
      current_balance_cents
      first_snapshot_day
      upcoming {
        ...WalletStatementLineFields
      }
      days {
        day
        closing_balance_cents
        lines {
          ...WalletStatementLineFields
        }
      }
    }
  }
  ${WALLET_STATEMENT_LINE_FIELDS}
`;
